import { UserFeatureFlag } from '@@types/api.types';

const validUserFeatureFlags = new Set<string>(Object.values(UserFeatureFlag));

export const isUserFeatureFlag = (value: string): value is UserFeatureFlag => {
  return validUserFeatureFlags.has(value);
};

export const sanitizeUserFeatureFlags = (featureFlags?: readonly string[] | null): UserFeatureFlag[] => {
  if (!featureFlags) {
    return [];
  }

  return featureFlags.filter(isUserFeatureFlag);
};
